import APPS from '@/data/mock/apps'
import BOARDS from '@/data/mock/boards'
import PROJECTS from '@/data/mock/projects'
import THREADS from '@/data/mock/threads'

export function getTopBoards(limit = 5) {
  return BOARDS.slice(0, limit)
}

export function getAllBoards() {
  return BOARDS
}

/** Dummy app ids shown in the home Apps section. */
export const DUMMY_PINNED_APP_IDS = [
  'app-lead-generation',
  'app-marketing-automation',
  'app-payment-reconciliation',
]

/**
 * @param {number} [limit]
 */
export function getTopApps(limit = 5) {
  return APPS.slice(0, limit)
}

export function getPinnedApps() {
  return APPS.filter((app) => DUMMY_PINNED_APP_IDS.includes(app.id))
}

export function getAllApps() {
  return APPS
}

/** Dummy project ids shown as pinned in the DO Code rail. */
export const DUMMY_PINNED_PROJECT_IDS = ['project-1', 'project-3']

export function getAllProjects() {
  return PROJECTS
}

export function getPinnedProjectIds() {
  return DUMMY_PINNED_PROJECT_IDS
}

export function getThreads() {
  return THREADS
}
